import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

// hixme-ui
import Container from '@hixme-ui/container'
import Text from '@hixme-ui/text'

import CartSummaryModal from 'components/Cart/CartSummaryModal'
import HeaderEmployerSelector from 'components/HeaderEmployerSelector'
import classes from './Header.scss'

export const Header = ({
  showHelpModal,
  companyName,
  hideCartSummary,
  isGuestUser,
  memberships,
  currentPersonId,
  onEmployerChange,
  employerSwitchDisabled,
}) => (
  <Container flex noPadding flexGrow={1} minWidth="0" height="100%" className={classes.root}>
    <Container flex noPadding minWidth="0" width="100%" justifyContent="space-between">
      <Container
        flex
        noPadding
        flexGrow={1}
        minWidth="0"
        height="100%"
        alignItems="center"
        className={classes.main}
      >
        <div className={classes.separator} />
        <Link to="/">
          <Container flex noPadding alignItems="center">
            <img alt="logo" className={classes.logo} src="/assets/sureco_ep_logo.png" />
          </Container>
        </Link>
        <div className={classes.separator} />
        <div className={classes.employerSelector}>
          <HeaderEmployerSelector
            memberships={memberships}
            currentPersonId={currentPersonId}
            companyNameFallback={companyName}
            onChange={onEmployerChange}
            disabled={employerSwitchDisabled}
          />
        </div>
      </Container>

      <Container
        flex
        noPadding
        flexShrink={0}
        alignItems="center"
        justifyContent="flex-end"
        className={classes.actions}
      >
        <div className={classes.helpSection}>
          <Container flex noPadding alignItems="center">
            <Text onClick={showHelpModal} cursor="pointer" className="mr-10">
              Need help
            </Text>
            <Text onClick={showHelpModal} cursor="pointer">
              <div className={classes.circleButton}>
                <Text blue large>
                  ?
                </Text>
              </div>
            </Text>
          </Container>

          {(!hideCartSummary || isGuestUser) && <div className={classes.separator} />}
        </div>

        {(!hideCartSummary || isGuestUser) && <CartSummaryModal />}
      </Container>
    </Container>
  </Container>
)

Header.propTypes = {
  showHelpModal: PropTypes.func,
  companyName: PropTypes.string,
  hideCartSummary: PropTypes.bool,
  isGuestUser: PropTypes.bool,
  memberships: PropTypes.array,
  currentPersonId: PropTypes.string,
  onEmployerChange: PropTypes.func,
  employerSwitchDisabled: PropTypes.bool,
}

Header.defaultProps = {
  showHelpModal: () => {},
  companyName: '',
  hideCartSummary: false,
  isGuestUser: false,
  memberships: [],
  currentPersonId: '',
  onEmployerChange: () => {},
  employerSwitchDisabled: false,
}

export default Header
